/* src/app/pages/ui-kit/components/chip-view/chip-view.component.scss */
.chip-view {
  padding: 20px;
}
.chip-view .section {
  margin-bottom: 30px;
}
.chip-view .section h3 {
  margin-bottom: 15px;
  color: var(--text-color-secondary);
  font-weight: 600;
}
.chip-view .section .section-hint {
  margin: -8px 0 15px;
  font-size: 14px;
  color: var(--text-color-secondary);
}
.chip-view .section .chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
/*# sourceMappingURL=chip-view.component.css.map */
